import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from "react-intl";
import { Link } from 'react-router-dom';
import * as paths from '@app/constants/paths';
// nodejs library that concatenates classes
import classNames from "classnames";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
// components
import CircularProgress from '@material-ui/core/CircularProgress';
import GridContainer from '@app/components/Grid/GridContainer';
import GridItem from '@app/components/Grid/GridItem';
import Card from '@app/components/Card/Card';
import CardHeader from '@app/components/Card/CardHeader';
import CardBody from '@app/components/Card/CardBody';
import CardFooter from '@app/components/Card/CardFooter';
import Button from '@app/components/CustomButtons/Button';
import CustomAccordion from "@app/components/Accordion/CustomAccordion";
import CustomInput from '@app/components/CustomInput/CustomInput';
import InputAdornment from "@material-ui/core/InputAdornment";
import Divider from '@material-ui/core/Divider';
// material-ui-core
import Radio from '@material-ui/core/Radio';
import Typography from '@material-ui/core/Typography';
import Checkbox from "@material-ui/core/Checkbox";
// icons
import Email from '@material-ui/icons/Email';
import SaveIcon from '@material-ui/icons/Save';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
// FontIcons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import withStyles from '@material-ui/core/styles/withStyles';
import surveyPageStyle from '@app/assets/jss/material-kit-pro-react/views/surveyPageStyle';
import { HmacSHA256 } from 'crypto-js';

const ProjectElementsView = (props) => {
    const classes = props.classes;
    // Options Messages
    const yes = props.intl.formatMessage({ id: "yes" });
    const no = props.intl.formatMessage({ id: "no" });
    const notSure = props.intl.formatMessage({ id: "not.sure" });

    const emailMarketingConsent = props.intl.formatMessage({ id: "i.would.like.a.quote" });
    const emailError = props.validationErrors.emailAddress.show;
    const emailHelperText = props.validationErrors.emailAddress.show ? props.validationErrors.emailAddress.errorMessage : '';
    const webAddressError = props.validationErrors.webAddress.show ;
    const webAddressHelperText = props.validationErrors.webAddress.show ? props.validationErrors.webAddress.errorMessage : '';
    
    return (
        <GridContainer justify='center'>
            <GridItem xs={12}>
                <form name="trading-online-voucher-scheme-2020" onSubmit={props.onSubmit}>    
                    <Card className={classes.cardSignUp}>
                        <CardHeader color='danger' className={classes.cardHeaderSignUp}>
                            <h3 className={classNames(classes.cardTitle, classes.title)} id="projectElements">
                                {window.location.pathname.startsWith(paths.HELPER_T_O_V_S_QUOTE) ? "Indicate Project Elements for Quote" : "Indicate Project Elements For Grant Support"}
                            </h3>
                        </CardHeader>
                        <CardBody className={classes.cardBodySignUp}>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>
                                                    <p>The work you seek to have done by the external service provider(s) will entail [select all applicable].</p>
                                                    <p>If you are not sure about any item, you should discuss it with someone you trust. Your application must indicate Yes or No for each item.</p>
                                                    <p>There are <b>18 work items</b> identified here, one being <b><i>other</i></b>, for anything not covered in the other 17 items.</p>
                                                    <h5 className={classes.title}>IT Consultation & Project Management</h5>
                                                    <p>The first two listed, <b>IT Consultation</b> and <b>Project Management</b> are quite generic and fairly standard for any Information Technology project. You can reasonably assume that any professional IT service provider will include IT consultation and Project Management in their services.</p>
                                                    <h5 className={classes.title}>New eCommerce website or Upgrade existing eCommerce website</h5>
                                                    <p>This scheme aims to get businesses trading online, so <b>developing a new</b> or <b>upgrading an existing eCommerce website</b> is likely a typical feature of most, if not all, Trading Online Voucher Scheme projects.</p>
                                                    <p>That's not to say that a business could not propose other project ideas that do not require the development or upgrading of an eCommerce website.</p>
                                                    <p>If a project idea shows innovation and potential for increased sales or employment, it will be considered.</p>
                                                    <h5 className={classes.title}>Content Management System (CMS)</h5>
                                                    <p>A <b>Content Management System (CMS)</b> is typically used to allow updating and publishing your website's content, such as blog posts and images, in a similar way as you would update a Word document or post something on Facebook.</p>
                                                    <p>You need to be comfortable and capable of producing content on a reasonably consistent basis if you are responsible for updating the content on your website.</p>
                                                    <p>A website needs to produce fresh content continually to keep and improve its search engine results ranking. There are many ways to create new content, and some can be automatic, and not all have to come from you. One of the best sources of fresh content is customers leaving reviews on a daily or weekly basis.</p>
                                                    <h5 className={classes.title}>Online Payments & Bookings</h5>
                                                    <p>Here are another two key work-types, <b>Implementing an online payments system</b> and <b>Implementing an interactive booking system</b>. If you currently cannot accept payments online (via Credit or Debit cards), then it's almost certain that your project would be expected to implement an online payments system on your website, thus making it an eCommerce website.</p>
                                                    <p>If you are in a service industry, then implementing an interactive booking system so your customers can book your services online, through your own website, especially when coupled with online payments, will be seen as a superb project proposal.</p>
                                                    <h5 className={classes.title}>App Development</h5>
                                                    <p><b>App Development</b> typically means a mobile app for Android and Apple phones and tablets. Given that the project is aimed at trading online, it may be more difficult to propose an app when an eCommerce website will be more suitable and efficient in probably 99.999% of cases!</p>
                                                    <p>That being said, it is entirely possible that an app may be the most suitable and appropriate solution for some niche or innovative use-cases.</p>
                                                    <p>App development is typically more expensive that website development. Costs of both continue to fall as new technologies and tools makes many common uses cases easier and quicker to develop.</p>
                                                    <h5 className={classes.title}>Digital Marketing & Online Advertising</h5>
                                                    <p><b>Development of a digital marketing strategy</b> and <b>Implementation of a digital marketing strategy</b> is likely to play a role in many Trading Online Voucher Scheme projects.</p>
                                                    <p>It cannot be understated how difficult it is to market a website. You can spend €0 and reach the top of the search results page on Google or spend infinite amounts of money and get nowhere.</p>
                                                    <p><b>Development</b> and <b>Implementation</b> of a <b>digital marketing strategy</b> re two separate work-types, as they are two different activities. Your supplier may do both or may develop the plan for you, offer you some training, and implement the strategy yourself.</p>
                                                    <p><b>Digital Marketing</b> is a huge topic, where much focus is on <b>Online Advertising</b>, which for the most part, essentially boils down to ads on screens. The advertising market, in general, is <a href="https://www.cnbc.com/2017/12/04/global-advertising-spend-2020-online-and-offline-ad-spend-to-be-equal.html" target="_blank" rel="noopener">growing online</a>:</p>
                                                    <blockquote cite="https://www.cnbc.com/2017/12/04/global-advertising-spend-2020-online-and-offline-ad-spend-to-be-equal.html">
                                                        Half of all global advertising dollars will be spent online by 2020, matching the worldwide combined “offline” ad spend, such as TV, print ads and billboard posters, according to forecasts.
                                                    </blockquote>
                                                    <p><a href="https://ads.google.com" target="_blank" rel="noopener">Google</a> dominates online advertising with its leading search engine, and <a href="https://www.facebook.com/business/ads" target="_blank" rel="noopener">Facebook</a> with their near-total <a href="https://www.statista.com/statistics/264810/number-of-monthly-active-facebook-users-worldwide/" target="_blank" rel="noopner">dominance social media</a>.</p>
                                                    <p>However, purchasing digital ads is a more advanced strategy. Many free strategies should be used first.</p>
                                                    <p>Probably the most important digital marketing strategy there is free. Get your business listed on <a href="https://www.google.com/intl/en_ie/business/" target="_blank" rel="noopener">Google My Business</a>. Their tagline says it all: </p>
                                                    <blockquote cite="https://www.google.com/intl/en_ie/business/">
                                                        With a Google My Business Account, you get more than a business listing. Your free Business Profile lets you easily connect with customers across Google Search and Maps. 
                                                    </blockquote>
                                                    <h5 className={classes.title}>Professional Photography</h5>
                                                    <p><b>Professional Photography</b> is vital for particular projects, especially where there are few or no available high-quality product photos. High-quality photos can be particularly useful for gaining new customers via social media or essential for creating product imagery for your online store.</p>
                                                    <h5 className={classes.title}>Subscription for Online Retail Platform Solutions</h5>
                                                    <p><b>Subscription to low-cost online retail platform solutions</b> is given to mean a year's subscription to a platform such as <a href="https://www.shopify.com/" target="_blank" rel="noopener">Shopify</a> for businesses that sell consumer goods, or <a href="http://localpro.ie/sign-up/user/professional" target="_blank">LocalPro.ie</a> for those that sell services. Here at <a href="http://localpro.ie/sign-up/user/professional" target="_blank">LocalPro.ie</a> we'll offer 5 to 10 year plans for Trading Online Voucher Scheme applicants. <a href="http://localpro.ie/contact-us?utm_source=localpro.ie&utm_medium=HC&utm_campaign=TOVS-2020" target="_blank">Contact us</a> to learn more.</p>
                                                    <h5 className={classes.title}>Training</h5>
                                                    <p>The Trading Online Project Scheme is designed to get you up-and-running online. It is expected that you will need to do some amount of work to continue  maintenance and updating of your website, or that you will continue to pay someone to do it for you. Either way, it will be seen as prudent in your application to get some training, at least 3 hours, so that you understand the nature of your online business presence.</p>
                                                    <h5 className={classes.title}>Copy</h5>
                                                    <p><b>Copy [written or graphic content] for a website</b> is a significant part of any website. The quality of the content on a website probably plays the most critical role in determining a web page's ranking on the search engine results page.  It also has a knock-on effect on ads' cost if one were to start a Pay-Per-Click Google Ads campaign. Suppose your content is better than anyone else. In that case, you will get a lower cost-per-click rate, or even better, an organic listing click that costs you nothing at all.</p>
                                                    <p>Google is playing a balancing act between showing the best results to their users to keep using Google and trying to earn some money from users clicking Pay-Per-Click ad search results.</p>
                                                    <h5 className={classes.title}>SEO</h5>
                                                    <p><b>Search Engine Optimisation (SEO)</b> is probably the most commonly used acronym in the online business world, with good reason. It's imperative, and it covers a lot of multitude of activities, processes and standards.</p>
                                                    <p>Essentially it is what it says it is; it is about optimising your website for search engines like Google and social media platforms like Facebook. Your website must be optimised for these search networks and social media platforms. This is how you will generate 99.999% of new online customers. Only your friends, family and existing customers might find your website without first going through a Google search or seeing a Facebook post.</p>
                                                    <h5 className={classes.title}>Analytics</h5>
                                                    <p><b>Analysis of existing site analytics</b> is collecting and assessing data collected about user behaviour and actions on your website. Users are tracked online to a considerable degree. Tracking is used to enhance a business's ability to understand customer behaviour. It helps gain insights into actions that may be taken to improve the likelihood of completing a sale or driving repeat customers.</p>
                                                    <p>If you have existing site analytics, it will boost your application strength if you leverage this data.</p>
                                                    <h5 className={classes.title}>Other</h5>
                                                    <p>Since online technology moves so fast, and nobody knows your business better than you, there is room for you to propose additional work items that do not fit into any of the categories listed.</p>
                                                    <p>Just keep in mind the main criteria. Anything not related to helping you trade online will not be accepted.</p>
                                                </span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <h4 className={classes.title} id="itConsultation">
                                IT Consultation&nbsp;
                                {props.validationErrors.itConsultation.check === null ? ' ' : (props.validationErrors.itConsultation.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "Since the voucher is only for those without the skills in-house, most applications will involve some IT consultation. This might be just the initial chat with a web designer or developer."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleITConsultation}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'chalkboard-teacher']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'chalkboard-teacher']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.itConsultation === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleITConsultation}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.itConsultation === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleITConsultation}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.itConsultation === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <hr/>
                            <h4 className={classes.title} id="projectManagement">
                                Project Management&nbsp;
                                {props.validationErrors.projectManagement.check === null ? ' ' : (props.validationErrors.projectManagement.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "The project should be managed by someone, and while a real-deal project manager is great to have, in most cases an IT consultant should suffice."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleProjectManagement}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'user-shield']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'user-shield']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.projectManagement === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleProjectManagement}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.projectManagement === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleProjectManagement}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.projectManagement === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <hr/>
                            <h4 className={classes.title} id="newECommerceSite">
                                New eCommerce website&nbsp;
                                {props.validationErrors.newECommerceSite.check === null ? ' ' : (props.validationErrors.newECommerceSite.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "If you don't already have an e-commerce website, where your customers can either pay you or book you, your project will typically be expected to develop one."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleNewECommerceSite}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'cash-register']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'cash-register']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.newECommerceSite === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleNewECommerceSite}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.newECommerceSite === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleNewECommerceSite}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.newECommerceSite === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <hr/>
                            <h4 className={classes.title} id="upgradeECommerceSite">
                                Upgrade existing eCommerce website&nbsp;
                                {props.validationErrors.upgradeECommerceSite.check === null ? ' ' : (props.validationErrors.upgradeECommerceSite.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "If you already have an e-commerce website, where your customers can either pay you or book you, your project will typically be expected to upgrade it if it needs maintenance."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleUpgradeECommerceSite}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'cash-register']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'cash-register']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.upgradeECommerceSite === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleUpgradeECommerceSite}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.upgradeECommerceSite === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleUpgradeECommerceSite}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.upgradeECommerceSite === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <hr/>
                            <h4 className={classes.title} id="cms">
                                Content Management System (CMS)&nbsp;
                                {props.validationErrors.cms.check === null ? ' ' : (props.validationErrors.cms.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "A CMS should make updating your website as easy as writing an email or posting on Facebook."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleCms}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'file-alt']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'file-alt']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.cms === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleCms}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.cms === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleCms}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.cms === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <hr/>
                            <h4 className={classes.title} id="onlinePayments">
                                Implementing an online payments system&nbsp;
                                {props.validationErrors.onlinePayments.check === null ? ' ' : (props.validationErrors.onlinePayments.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "Allowing your customers to make payments to you on your website. This is something your LEO likes to see in applications."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleOnlinePayments}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'credit-card']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'credit-card']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.onlinePayments === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleOnlinePayments}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.onlinePayments === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleOnlinePayments}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.onlinePayments === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <hr/>
                            <h4 className={classes.title} id="bookingSystem">
                                Implementing an interactive booking system&nbsp;
                                {props.validationErrors.bookingSystem.check === null ? ' ' : (props.validationErrors.bookingSystem.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "Allowing your customers to make appointments with you on your website. This is something your LEO likes to see in applications."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleBookingSystem}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'calendar-alt']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'calendar-alt']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.bookingSystem === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleBookingSystem}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.bookingSystem === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleBookingSystem}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.bookingSystem === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <hr/>
                            <h4 className={classes.title} id="app">
                                App development&nbsp;
                                {props.validationErrors.app.check === null ? ' ' : (props.validationErrors.app.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "In most cases an eCommerce website will suffice and an app will not be deemed a suitable use of the voucher."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleApp}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'mobile-alt']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'mobile-alt']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.app === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleApp}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.app === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleApp}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.app === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <hr/>
                            <h4 className={classes.title} id="digitalMarketingDev">
                                Development of a digital marketing strategy&nbsp;
                                {props.validationErrors.digitalMarketingDev.check === null ? ' ' : (props.validationErrors.digitalMarketingDev.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "Google and Facebook owned platforms dominate digital marketing. If not used wisely, money is easily and quickly wasted."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleDigitalMarketingDev}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'ad']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'ad']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.digitalMarketingDev === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleDigitalMarketingDev}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.digitalMarketingDev === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleDigitalMarketingDev}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.digitalMarketingDev === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <hr/>
                            <h4 className={classes.title} id="digitalMarketingImp">
                                Implementation of a digital marketing strategy&nbsp;
                                {props.validationErrors.digitalMarketingImp.check === null ? ' ' : (props.validationErrors.digitalMarketingImp.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "Digital marketing requires more management in the early stages. Often free credits are available to new users. This credit is useful to do some early test marketing campaigns."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleDigitalMarketingImp}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fab', 'adversal']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fab', 'adversal']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.digitalMarketingImp === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleDigitalMarketingImp}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.digitalMarketingImp === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleDigitalMarketingImp}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.digitalMarketingImp === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <hr/>
                            <h4 className={classes.title} id="onlineAds">
                                Online Advertising&nbsp;
                                {props.validationErrors.onlineAds.check === null ? ' ' : (props.validationErrors.onlineAds.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "Purchase of online advertising cannot make up more than 30% (circa €575) of all other approved costs."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleOnlineAds}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fab', 'buysellads']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fab', 'buysellads']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.onlineAds === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleOnlineAds}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.onlineAds === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleOnlineAds}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.onlineAds === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <hr/>
                            <h4 className={classes.title} id="proPhoto">
                                Professional Photography&nbsp;
                                {props.validationErrors.proPhoto.check === null ? ' ' : (props.validationErrors.proPhoto.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "Purchase of professional photography cannot make up more than 80% (circa €1,120) of all other approved costs."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleProPhoto}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'photo-video']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'photo-video']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.proPhoto === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleProPhoto}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.proPhoto === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleProPhoto}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.proPhoto === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <hr/>
                            <h4 className={classes.title} id="subscriptionLowCostRetail">
                                Subscription to low-cost online retail platform solutions&nbsp;
                                {props.validationErrors.subscriptionLowCostRetail.check === null ? ' ' : (props.validationErrors.subscriptionLowCostRetail.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "If you are selling consumer good this means Shopify. If you are selling services, we'll make this mean LocalPro!"
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleSubscriptionLowCostRetail}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'map-marker-alt']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'map-marker-alt']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.subscriptionLowCostRetail === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleSubscriptionLowCostRetail}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.subscriptionLowCostRetail === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleSubscriptionLowCostRetail}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.subscriptionLowCostRetail === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <hr/>
                            <h4 className={classes.title} id="training">
                                Training specific to the establishment of trading online&nbsp;
                                {props.validationErrors.training.check === null ? ' ' : (props.validationErrors.training.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "It will boost your application if you show that you are willing to learn a little about trading online. The mandatory webinar required to get approval is a good example to start with. "
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleTraining}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'chalkboard-teacher']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'chalkboard-teacher']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.training === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleTraining}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.training === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleTraining}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.training === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <hr/>
                            <h4 className={classes.title} id="copy">
                                Copy [written or graphic content] for website&nbsp;
                                {props.validationErrors.copy.check === null ? ' ' : (props.validationErrors.copy.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "Good content will boost your internet search result ranking and reduce or even eliminate the need to pay for clicks."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleCopy}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'file-invoice']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'file-invoice']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.copy === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleCopy}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.copy === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleCopy}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.copy === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <hr/>
                            <h4 className={classes.title} id="seo">
                                Search Engine Optimisation (SEO)&nbsp;
                                {props.validationErrors.seo.check === null ? ' ' : (props.validationErrors.seo.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "The process of optimising the visibility of a website or webpage in a search engine's organic (not an ad) search results."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleSeo}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'crosshairs']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'crosshairs']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.seo === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleSeo}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.seo === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleSeo}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.seo === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <hr/>
                            <h4 className={classes.title} id="analytics">
                                Analysis of existing site analytics&nbsp;
                                {props.validationErrors.analytics.check === null ? ' ' : (props.validationErrors.analytics.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "Analysing web data for purposes of understanding and optimizing web usage."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleAnalytics}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'chart-bar']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'chart-bar']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.analytics === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleAnalytics}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.analytics === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleAnalytics}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.analytics === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <hr/>
                            <h4 className={classes.title} id="other">
                                Other&nbsp;
                                {props.validationErrors.other.check === null ? ' ' : (props.validationErrors.other.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                "Things move fast online and you know your business best. Don't be afraid to propose something not listed above. However, if it doesn't seem like it will boost your ability to trade online, it likely won't be accepted."
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleOther}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'hat-wizard']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'hat-wizard']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.other === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleOther}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'times-circle']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                checked: classes.iconCheckboxChecked,
                                                root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.other === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleOther}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.other === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                        {!window.location.pathname.startsWith(paths.HELPER_T_O_V_S_QUOTE) && <CardFooter className={classes.cardFooterSignUp}>
                            <div className={classes.cardBodySignUpButtons}>
                                <Button color="gray" component={ Link } to={paths.HELPER_T_O_V_S}>
                                    Main Menu
                                </Button>
                                <Button
                                    color="primary"
                                    size="sm"
                                    startIcon={<SaveIcon />}
                                    onClick={props.generateDoc}
                                >
                                    Download
                                </Button>
                            </div>
                        </CardFooter>}
                        {!window.location.pathname.startsWith(paths.HELPER_T_O_V_S_QUOTE) && <CardFooter className={classes.cardFooterSignUp}>
                            <div className={classes.cardBodySignUpButtons}>
                                <Button color='primary' component={ Link } to={paths.HELPER_T_O_V_S_OUTCOMES}>
                                    &lt; Projected Outcomes 
                                </Button>
                                <Button color='primary' component={ Link } to={paths.HELPER_T_O_V_S_COSTS}>
                                    Project Costs &gt;
                                </Button>
                            </div>
                        </CardFooter>}
                        <Divider className={classes.divider}/>
                        <h5 className={classes.title} id="quoteEmailAddress">
                            Email Me A Quote&nbsp;
                            {props.validationErrors.emailAddress.check === null ? ' ' : (props.validationErrors.emailAddress.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                        </h5>
                        <CardFooter className={classes.cardFooterSignUp}>
                            <div className={classes.cardBodySignUpButtons}>
                                <CustomInput
                                    id='emailAddress'
                                    labelText=''
                                    helperText={emailHelperText}
                                    error={emailError}
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={{
                                        name: 'emailAddress',
                                        value: props.emailAddress,
                                        onChange: props.onEmailChange,
                                        autoComplete: 'off',
                                        startAdornment: (
                                            <InputAdornment position='start'>
                                                <Email className={classes.inputIconsColor} />
                                            </InputAdornment>
                                        ),
                                        placeholder: "name@email.domain"
                                    }}
                                />
                            </div>
                        </CardFooter>
                        <h5 className={classes.title} id="quoteWebAddress">
                            Website Address&nbsp;
                            {props.validationErrors.webAddress.check === null ? ' ' : (props.validationErrors.webAddress.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                        </h5>
                        <CardFooter className={classes.cardFooterSignUp}>
                            <div className={classes.cardBodySignUpButtons}>
                                <CustomInput
                                    id='webAddressInput'
                                    labelText=''
                                    helperText={webAddressHelperText}
                                    error={webAddressError}
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={{
                                        name: 'webAddress',
                                        value: props.webAddress,
                                        onChange: props.onWebsiteChange,
                                        autoComplete: 'off',
                                        startAdornment: (
                                            <InputAdornment position='start'>
                                                <FontAwesomeIcon icon={['fas', 'globe']} className={classes.inputIconsColor} />
                                            </InputAdornment>
                                        ),
                                        placeholder: "MyBrilliantWebsite.ie"
                                    }}
                                />
                            </div>
                        </CardFooter>
                        {(props.successMessage != '' || props.errorMessage != '') ? (props.successMessage != '' ? <div><Divider className={classes.divider}/><h6 className={classes.title} id="quoteResponseMessage">{props.successMessage}</h6></div> : <div><Divider className={classes.divider}/><h6 className={classes.title} id="quoteResponseMessage">{props.errorMessage}</h6></div>) : ''}
                        <CardFooter className={classes.cardFooterSignUp}>
                            <div className={classes.cardBodySignUpButtons}>
                                <FormControl required error={props.errorMessage != ''} component="fieldset">
                                    <FormControlLabel
                                        control={
                                                <Checkbox
                                                    tabIndex={-1}
                                                    onChange={props.handleChange}
                                                    checkedIcon={<CheckIcon className={classes.checkedIcon} />}
                                                    icon={<CheckIcon className={classes.uncheckedIcon} />}
                                                    classes={{
                                                        checked: classes.checked,
                                                        root: classes.checkRoot
                                                    }}
                                                    checked={props.emailConsent}
                                                />
                                            }
                                            value="emailConsent"
                                            classes={{ label: classes.label }}
                                            label={props.validationErrors.emailConsent.check === false ? <b><u>{emailMarketingConsent}</u></b> : emailMarketingConsent}
                                    />
                                </FormControl>
                                {props.isLoading &&
                                    <div className={classes.progress}>
                                        <CircularProgress />
                                    </div>
                                }
                                <Button
                                    color={props.successMessage != '' ? "success" : (props.errorMessage != '' ? "warning" : "danger")}
                                    size="sm"
                                    startIcon={props.successMessage != '' ? <CheckIcon /> : <SaveIcon />}
                                    onClick={props.generateQuote}
                                    disabled={(props.successMessage != '')}
                                >
                                    {(props.successMessage != '' && props.errorMessage != '') ? (props.successMessage != '' ? "Success!" : "Error!") : "Quote Me"}
                                </Button>
                            </div>
                        </CardFooter>
                    </Card>
                </form>
            </GridItem>
        </GridContainer>
    );
}

ProjectElementsView.propTypes = {
    locale: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    handleChange: PropTypes.func.isRequired,
    onEmailChange: PropTypes.func.isRequired,
    onWebsiteChange: PropTypes.func.isRequired,
    generateDoc: PropTypes.func.isRequired,
    generateQuote: PropTypes.func.isRequired
};

export default injectIntl(withStyles(surveyPageStyle)(ProjectElementsView));